export default __webpack_public_path__ + "static/Mining_Drill-d9a9b7cb8e81d746f65fc9d830774b91.png";